import { ReactNode } from "react";
import { Link } from "react-router-dom";
import clsx from "clsx";

export const DesktopMenuItem = ({
  href,
  icon,
  label,
  isActive,
}: {
  href: string;
  icon: ReactNode;
  label: string;
  isActive: boolean;
}) => (
  <Link
    to={href}
    className={clsx(
      "flex h-12 items-center gap-x-3 rounded-lg px-6 text-button text-black-70 hover:bg-primary-108 hover:text-primary-300",
      isActive && "bg-primary-108 text-primary-300",
    )}
  >
    {icon}
    {label}
  </Link>
);
